import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Calendar
} from 'react-big-calendar'
import {
  Dropdown,
  Input,
  Button,
  Checkbox
} from 'semantic-ui-react'

const CardDentistScheduleUX = (props: any) => {
    return(
      <div
        id="CardDentistScheduleUX-div-0"
        style={{height: "100%", display: "flex"}}>
        <div
          className="ui form --override-disabled --grey"
          id="CardDentistScheduleUX-div-4"
          style={{flex: "1 1 0%",overflowY:"scroll",height:"100%", minWidth: "30%"}}>

          <div
            id="CardDentistScheduleUX-div-37"
            style={{display: "flex", alignItems: "center", marginBottom: "0.5rem"}}>

            <label
              id="CardDentistScheduleUX-label-38"
              style={{marginRight: "0.75rem"}}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </label>
            <Dropdown
              fluid={true}
              id="CardDentistScheduleUX-Dropdown-39"
              onChange={props.onChangeDivision}
              options={props.divisionOptions}
              placeholder="Please select the division"
              search={true}
              selectOnBlur={false}
              selection={true}
              value={props.selectedDivisionId}>
            </Dropdown>
          </div>
          <div
            id="CardDentistScheduleUX-div-2"
            style={{...(props.telephar && {display : "none" })}}>
            {props.providerSelector}
          </div>
          <div
            id="CardDentistScheduleUX-div-7"
            style={{marginTop: "10px", display: props.telephar && !props.showSlotLength? "none" : "flex", flexDirection: "column"}}>

            <div
              id="CardDentistScheduleUX-div-33"
              style={{...(!props.isShowChair && { display: "none" }) }}>

              <div
                id="CardDentistScheduleUX-div-34">
                {props.languageUX === "en" ? "Type of inspection" : "ประเภทการออกตรวจ"}
              </div>
              <Dropdown
                disabled={props.disabledExaminationType || false}
                fluid={true}
                id="CardDentistScheduleUX-Dropdown-35"
                onChange={props.onChangeExaminationType}
                options={props.examinationTypeOptions}
                selection={true}
                value={props.examinationType}>
              </Dropdown>
            </div>
            <div
              id="CardDentistScheduleUX-div-23"
              style={{flex: 1}}>

              <div
                id="CardDentistScheduleUX-div-14">
                {props.languageUX === "en" ? "Service time per patient (minutes)" : "เวลาให้บริการต่อคนไข้ (นาที)"}
              </div>
              <Input
                fluid={true}
                id="CardDentistScheduleUX-Input-26"
                onChange={props.changeDefaultSlotLength}
                value={props.defaultSlotLength}>
              </Input>
            </div>
            <div
              id="CardDentistScheduleUX-div-22"
              style={{flex: 1, ...(!props.isShowChair && { display: "none" }) }}>

              <div
                id="CardDentistScheduleUX-div-6">
                {props.languageUX === "en" ? "Select a chair for the table." : "เลือกเก้าอี้สำหรับการลงตาราง"}
              </div>
              <Dropdown
                fluid={true}
                id="CardDentistScheduleUX-Dropdown-5"
                onChange={props.changeDefaultChair}
                options={props.chairOptions}
                selection={true}
                value={props.defaultChair}>
              </Dropdown>
            </div>
          </div>
          <div
            id="CardDentistScheduleUX-div-30"
            style={{display:props.telephar&&!props.showSlotLength? "none" : "flex", padding: "5px"}}>

            <Checkbox
              checked={props.exceptNewPatientAll}
              id="CardDentistScheduleUX-Checkbox-31"
              onChange={props.changeExceptNewPatientAll}
              style={{marginRight: "7px"}}>
            </Checkbox>
            <label
              id="CardDentistScheduleUX-label-32">
              {props.languageUX === "en" ? "Not accepting new patients" : "ไม่รับผู้ป่วยใหม่"}
            </label>
          </div>
          <div
            id="CardDentistScheduleUX-div-27">
            {props.cardSelectTemplate}
          </div>
        </div>
        <div
          id="CardDentistScheduleUX-div-3"
          style={{ flex: 3, height: "100%", maxWidth: "70%", position: "relative"}}>

          <div
            id="CardDentistScheduleUX-div-29"
            style={{paddingBottom: "5px", display: "flex", justifyContent: "flex-end"}}>

            <Button
              color="green"
              disabled={props.disablePrint}
              id="CardDentistScheduleUX-Button-28"
              onClick={props.printSummary}
              size="tiny">
              {props.languageUX === "en" ? "Print work schedule summary" : "พิมพ์สรุปตารางการทำงาน"}
            </Button>
          </div>
          <div
            id="CardDentistScheduleUX-div-40">
            {props.calendarLoader}
          </div>
          <Calendar
            eventPropGetter={props.eventPropGetter}
            events={props.blockList || []}
            formats={props.formats}
            id="CardDentistScheduleUX-Calendar-1"
            localizer={props.localizer}
            max={props.maxTime}
            min={props.minTime}
            onNavigate={props.onNavigate}
            onRangeChange={props.onRangeChange}
            onSelectEvent={props.onSelectEvent}
            views={["month", "week", "day"]}>
          </Calendar>
        </div>
      </div>
    )
}


export default CardDentistScheduleUX

export const screenPropsDefault = {"cardSelectTemplate":"[CardSelectTemplate]","providerSelector":"[ProviderSelector]"}

/* Date Time : Mon Oct 06 2025 11:30:12 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "react-big-calendar",
      "id": 1,
      "name": "Calendar",
      "parent": 3,
      "props": {
        "eventPropGetter": {
          "type": "code",
          "value": "props.eventPropGetter"
        },
        "events": {
          "type": "code",
          "value": "props.blockList || []"
        },
        "formats": {
          "type": "code",
          "value": "props.formats"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Calendar-1"
        },
        "localizer": {
          "type": "code",
          "value": "props.localizer"
        },
        "max": {
          "type": "code",
          "value": "props.maxTime"
        },
        "min": {
          "type": "code",
          "value": "props.minTime"
        },
        "onNavigate": {
          "type": "code",
          "value": "props.onNavigate"
        },
        "onRangeChange": {
          "type": "code",
          "value": "props.onRangeChange"
        },
        "onSelectEvent": {
          "type": "code",
          "value": "props.onSelectEvent"
        },
        "views": {
          "type": "code",
          "value": "[\"month\", \"week\", \"day\"]"
        }
      },
      "seq": 40,
      "void": true
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.providerSelector"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{...(props.telephar && {display : \"none\" })}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 3, height: \"100%\", maxWidth: \"70%\", position: \"relative\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"1 1 0%\",overflowY:\"scroll\",height:\"100%\", minWidth: \"30%\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Dropdown-5"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDefaultChair"
        },
        "options": {
          "type": "code",
          "value": "props.chairOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.defaultChair"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกเก้าอี้สำหรับการลงตาราง",
          "valueEN": "Select a chair for the table."
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"10px\", display: props.telephar && !props.showSlotLength? \"none\" : \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ลงตารางโดยอ้างอิงจากเทมเพลทตารางคลีนิค",
          "valueEN": "Table is entered based on the clinic table template."
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"15px 0 0 0\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาให้บริการต่อคนไข้ (นาที)",
          "valueEN": "Service time per patient (minutes)"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1, ...(!props.isShowChair && { display: \"none\" }) }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Input",
      "parent": 23,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Input-26"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDefaultSlotLength"
        },
        "value": {
          "type": "code",
          "value": "props.defaultSlotLength"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardSelectTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-27"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Button",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์สรุปตารางการทำงาน",
          "valueEN": "Print work schedule summary"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disablePrint"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Button-28"
        },
        "onClick": {
          "type": "code",
          "value": "props.printSummary"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"5px\", display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{display:props.telephar&&!props.showSlotLength? \"none\" : \"flex\", padding: \"5px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Checkbox",
      "parent": 30,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.exceptNewPatientAll"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Checkbox-31"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeExceptNewPatientAll"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"7px\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ไม่รับผู้ป่วยใหม่",
          "valueEN": "Not accepting new patients"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-label-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.isShowChair && { display: \"none\" }) }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทการออกตรวจ",
          "valueEN": "Type of inspection"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 33,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledExaminationType || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Dropdown-35"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeExaminationType"
        },
        "options": {
          "type": "code",
          "value": "props.examinationTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.examinationType"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Dropdown",
      "parent": 37,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-Dropdown-39"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Please select the division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "false"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calendarLoader"
        },
        "id": {
          "type": "value",
          "value": "CardDentistScheduleUX-div-40"
        }
      },
      "seq": 29,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDentistScheduleUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "cardSelectTemplate": "[CardSelectTemplate]",
    "providerSelector": "[ProviderSelector]"
  },
  "width": 80
}

*********************************************************************************** */
